import {InputTextV2} from '@prtimes-basis/input';
import styles from './address1-field.module.css';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function Address1Field() {
  return (
    <FormField.Root name='billingInfo.address'>
      <div className={styles.container}>
        <Body />

        <FormField.Error />
      </div>
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField();

  return (
    <>
      <label
        htmlFor={fieldProps.id}
        className={companyRegistrationPageStyles.srOnly}
      >
        請求先住所（都道府県 / 市町村 / 番地）
      </label>

      <InputTextV2
        required
        placeholder='住所（都道府県 / 市町村 / 番地）'
        {...fieldProps}
      />
    </>
  );
}
